module.exports = __webpack_public_path__ + "static/media/W19-1293_Mushroom_Mozza_Mobile_767x845_en.0b70bbc6.jpg";